export enum TabKind {
  DASHBOARD = 0,
  PROBLEMS = 1,
  SCOREBOARD = 2,
  ANNOUNCEMENTS = 3,
  SUPPORT = 4,
  PLAYGROUND = 5,
  RESULTS = 6,
  SOURCECODE = 7,
  SPECIFICATION = 8,
}

export enum TabURL {
  DASHBOARD = 'dashboard',
  PROBLEMS = 'problems',
  SCOREBOARD = 'scoreboard',
  ANNOUNCEMENTS = 'announcements',
  SUPPORT = 'support',
  LOGIN = 'login',
  PLAYGROUND = 'playground',
  RESET_PASSWORD = 'reset-password',
  RESULTS = 'results',
  SOURCE_CODE = 'sourcecode',
  SPECIFICATION = 'specification',
}
